interface PDFViewerProps {
  pdfUrl: string;
}

// Render the PDF with the browser's native viewer via an <iframe>. Native
// rendering is a top-level navigation, so it is not subject to CORS the way a
// fetch/XHR-based viewer is — a cross-origin hosted PDF (e.g. the S3 agreement)
// loads without the bucket needing CORS headers.
const PDFViewer = ({ pdfUrl }: PDFViewerProps) => {
  return (
    <iframe
      title="pdf-viewer"
      src={pdfUrl}
      referrerPolicy="no-referrer"
      style={{ width: '100%', height: '100%', border: 'none' }}
    />
  );
};

export default PDFViewer;
